import { Grid, Typography } from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { useScrollButtonState } from '@ncr-retail/hooks';
import React from 'react';
import InteractiveDialogContent, {
  DialogBar,
} from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import InteractiveDialogueContainer from 'src/common/components/interactive-dialogue/components/interactive-dialogue-container';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { useTranslation } from 'react-i18next';
import { Pagination } from 'src/pagination/pagination';
import { styles } from './remove-items-modal-styles';

export const RemoveRejectedItemsModalId = 'RemoveRejectedItemsModal';

type Props = RemoveRejectedItemsProps;

export const showRemoveRejectedItemsModal = (props: Props): void => {
  pushEmeraldModal(<RemoveRejectedItemModal {...props} />, undefined, RemoveRejectedItemsModalId);
};

const TextContent: React.FC<RemoveRejectedItemsProps> = props => {
  const classes = styles();
  const { itemDescriptions } = props;
  const [{ currentPage, lastPage, onPageChanged }, scrollRef] = useScrollButtonState();
  const { t } = useTranslation();
  return (
    <Grid container justifyContent='center' direction='column'>
      <Grid item container direction='column' justifyContent='center'>
        <Typography className={classes.title}>{t('PleaseCollectItems')}</Typography>
        <DialogBar type={EmeraldDialogTypes.Warning} />
        <Grid data-testid='remove-items' className={`${classes.voidedItems}`}>
          <div
            ref={scrollRef}
            className={`verticalScroll fullHeight`}
            data-testid='remove-items-scroll'
          >
            {itemDescriptions.map((item, idx) => (
              <Grid key={idx} container ref={scrollRef} className={classes.itemList}>
                <Typography className={classes.messageLine}>
                  <ReportProblemOutlinedIcon className={classes.icon} />
                  {item}
                </Typography>
              </Grid>
            ))}
          </div>
        </Grid>
      </Grid>
      <Grid item container className={`${classes.arrows}`} justifyContent='space-evenly'>
        <Pagination
          currentPage={currentPage}
          totalPages={lastPage}
          updateCurrentPageHandler={onPageChanged}
          displayText={false}
          testIdPrefix={'remove-items-modal'}
        />
      </Grid>
    </Grid>
  );
};

const RemoveRejectedItemModal = (props: Props): JSX.Element => {
  const classes = styles();
  const { onClose } = props;
  return (
    <InteractiveDialogueContainer
      open
      hideCancelButton
      acceptButtonLabel={'Ok'}
      handleClose={onClose}
      handleAccept={onClose}
      dialogWidth={46.852}
      dialogMinWidthFlag={true}
      classes={{ dialogPaperFullWidth: classes.dialogPaperFullWidth }}
      dialogTestIdPrefix='remove-rejected-items-modal'
      component={
        <InteractiveDialogContent
          type={EmeraldDialogTypes.Warning}
          subMessage=''
          textContent={<TextContent itemDescriptions={props.itemDescriptions} onClose={onClose} />}
        />
      }
    />
  );
};
interface RemoveRejectedItemsProps {
  itemDescriptions: string[];
  onClose: () => void;
}
